// AppRouter.js
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contacts from "./pages/Contacts";
import Services from "./pages/Services";
import NewsPage from "./pages/NewsPage";
import Careers from "./pages/Careers";
import Reports from "./pages/Reports";
import Legal from "./pages/Legal";
import Tenders from "./pages/Tenders";
import Materials from "./pages/Materials";
import Structure from "./pages/Structure";
import NewsDetailPage from "./pages/NewsDetailPage";
import MaterialsDetailPage from "./pages/MaterialsDetailPage";
import UnderCunstruction from "./pages/UnderCunstruction";
import Banks from "./pages/Banks";
import UsefulLinks from "./pages/UsefulLinks";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Whistleblowing from "./pages/Whistleblowing";
import SearchPage from "./components/SearchPage";

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/documents" element={<Legal />} />
            <Route path="/tenders" element={<Tenders />} />
            <Route path="/materials" element={<Materials />} />
            <Route path="/materials/:id" element={<MaterialsDetailPage />} />
            <Route path="/banks" element={<Banks />} />
            <Route path="/useful-links" element={<UsefulLinks />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/whistleblowing" element={<Whistleblowing />} />
            {/* <Route path="/materials" element={<UnderCunstruction />} /> */}
            <Route path="/structure" element={<Structure />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="*" element={<Home />} />
        </Routes>
    );
};

export default AppRouter;
